import { AttachmentsHandlerFunction } from './types';

export const processAllAttachments = ({
  form,
  attachmentsByPseudoType,
}: AttachmentsHandlerFunction) => {
  return (
    form.attachments?.cards ??
    attachmentsByPseudoType[form.pseudoType]?.cards ??
    []
  );
};
